export const MyProfileSW = {
  SEND_INVITATION_TO_CLIENT:
    'Skicka inbjudan till kunden för att få tillgång till kontot',
  SENDED_INVITATION: 'Aktiveringsmail har skickats. Skicka igen.',
  GO_TO_ONBOARDING: 'Gå till Onboarding av kund',
  UPDATE_MESSAGE_SUCCESS: 'Dina ändringar har sparats',
  UPDATE_MESSAGE_ERROR: 'Någonting gick fel',
  DEACTIVATE_ADVISOR: 'Inaktivera rådgivare',
  ACTIVATE_ADVISOR: 'Aktivera rådgivare',
  EDIT_ADVISOR: 'Redigera rådgivare',
  ENABLE_2FA: 'Aktivera tvåfaktorsautentisering',
  INSTRUCTION:
    'För att få tillgång till hela funktionaliteten måste du ange och bekräfta BankID och/eller aktivera tvåfaktorsautentisering.',
  DELETE_PNUMBER: 'Radera personnummer',
  ALERT_ERROR: 'Fel. Du har inte verifierat ditt personnummer.',
  ALERT_SUCCESS: 'Lyckat. Du har verifierat ditt personnummer.',
  TITLE_2FA_MODAL: 'Konfigurera tvåfaktorsautentisering.',
  STEP_ONE_2FA_MODAL: 'Skaffa och installera Authenticator-app.',
  STEP_ONE_2FA_MODAL_TEXT:
    'Authenticator-appar och webbläsartillägg som 1Password, Authy, Microsoft Authenticator, Google Authenticator, etc. genererar engångslösenord som används som en säkerhetsåtgärd för att verifiera din identitet när du uppmanas till det under inloggningen.',
  STEP_TWO_2FA_MODAL:
    'Använd autentiseringsapp eller webbläsare för att skanna.',
  STEP_THREE_2FA_MODAL: 'Ange verifieringskod',
  STEP_THREE_2FA_MODAL_TEXT:
    'När streckkoden ovan har skannats anger du den 6-siffriga verifieringskoden som genereras av appen.',
  TWO_FACTOR_ACTIVATE_BTN: 'Verifiera koden och aktivera',
  DELETE_CLIENT: 'Ta bort kund',
  CREATED_DATE: 'Skapat datum',
  ACTION: 'Handling',
  INVITATION: 'Inbjudan',
  ONBOARDING: 'Onboarding',
  UNSAVED_CHANGES: 'Osparade ändringar',
  YOU_WANT_WITHOUT_SAVING_ON: 'Vill du lämna sidan utan att spara?',
  YOU_WANT_WITHOUT_SAVING_TWO:
    'Alla ändringar kommer att gå förlorade. Vill du lämna utan att spara?',
  LEAVE_WITHOUT_SAVING: 'Lämna utan att spara',
  MODAL_DELETE_TITLE: 'Bekräfta radering',
  MODAL_DELETE_TEXT: 'Är du säker på att du vill ta bort rådgivaren?',
  MODAL_DELETE_PERSON:
    'Är du säker på att du vill ta bort den relaterade personen?',
  MODAL_DELETE_TEXT_ASSET:
    'Är du säker på att du vill ta bort tillgångsklassen?',
  MODAL_DELETE_TEXT_CLIENT: 'Är du säker på att du vill ta bort kunden?',
  MODAL_DELETE_PORTFOLIO: 'Är du säker på att du vill ta bort portföljen:',
  LOCKED_PORTFOLIO_DELETE:
    'Den här portföljen kan inte raderas eftersom den är en del av en sammansatt portfölj. \nTa bort den från den sammansatta portföljen innan du fortsätter.',
  ENGLISH: 'English',
  SVENSKA: 'Svenska',
  LANGUAGE: 'Språk',
  MODAL_DELETE_PLAN:
    'Är du säker på att du vill ta bort den finansiella planen:',
  MODAL_DELETE_PLAN_STAGE: 'Är du säker på att du vill ta bort scenen:',
  DELETE_PLAN_STAGE_AT: 'vid finansiell plan:',
  TOTAL_INCOME: 'totalkomst',
  AVERAGE_ANNUAL_INCOME: 'Genomsnittlig årsinkomst',
  TOTAL_SPEND: 'totala utgifter',
  AVERAGE_ANNUAL_SPEND: 'Genomsnittliga årliga utgifter',
  SPEND: 'spendera',
  INCOME: 'inkomst',

  HOME_BASE: 'Hemmabas',
  HEALTH_AND_PROTECTION: 'Hälsa och skydd',
  MOBILITY: 'Rörlighet',
  CORE_SUPPORT: 'Kärnstöd',
  BASIC_FOOD: 'Grundläggande mat',
  BASIC_CLOTHING: 'Grundläggande kläder',
  CHILDREN_AND_EDUCATION: 'Barn och utbildning',
  FOOD_AND_DRINK_OUT: 'Mat och dryck ute',
  STYLE_AND_SELF: 'Stil och jag',
  LEARNING_AND_GROWTH: 'Lärande och tillväxt',
  TECH_AND_SUBSCRIPTIONS: 'Teknik och prenumerationer',
  GETAWAYS_AND_HOLIDAYS: 'Semesterresor och helgdagar',
  BIG_BUYS_AND_TOYS: 'Stora köp och leksaker',
  EVENTS_AND_EXPERIENCES: 'Evenemang och upplevelser',
  GIFTS_AND_GIVING: 'Gåvor och gåvor',
  SALARY: 'Lön',
  PENSION: 'Pension',
  OTHER_INCOME: 'Övriga inkomster',
  PROPERTY_SALES: 'Fastighetsförsäljning',
  RETURN_ON_INVESTMENT: 'Avkastning på investeringen',
  OTHER_SALE: 'Annan försäljning',
  INHERITANCE: 'Arv',
  PREV: 'Tidigare`',
  NEXT: 'Nästa',
  GIVE_IT_A_NAME: 'Ge det ett namn.',
  WHAT_SORT_OF_BUDGET_ARE_YOU_THINKING: 'Vilken sorts budget tänker du dig?',
  HOW_OFTEN_DO_YOU_WANT_TO_GO: 'Hur ofta vill du gå?',
  WHEN_DO_YOU_WANT_TO_DO_IT: 'När vill du göra det?',
  WHAT_LEVEL_OF_HAPPINESS_DOES_THIS_TRIP_PROVIDE_YOU_WITH:
    'Vilken nivå av lycka ger den här resan dig?',
  NOW_RANK_THIS_TRIP_IN_TERM_OF_PURPOSE: 'Rangordna nu resan efter syfte.',
  AND_LASTLY_WHERE_DOES_IT_RANK_IN_TERMS_OF_NEED_VS_WANT:
    'Och slutligen, var rankas det när det gäller behov kontra önskemål?',
  HOW_CERTAIN_ARE_YOU_ABOUT_THIS_SALE:
    'Hur säker är du på den här försäljningen?',
  VALIDATION_ERROR: 'Valideringsfel',
  VALIDATION_ERROR_TEXT: 'Fyll i alla obligatoriska fält. Fel: ',
  END_DATE_AFTER_START: 'Slutdatum efter startdatum',

  BASE_SALARY: 'Baslön',
  BONUS_COMMISSION: 'Bonus/Provision',
  EMPLOYER_BENEFITS: 'Arbetsgivarförmåner',
  DIVIDENDS_AND_INTEREST: 'Utdelningar och ränta',
  REALISED_GAINS: 'Realiserade vinster',
  RENTAL_INCOME: 'Hyresintäkter',
  FREELANCE_SIDE_INCOME: 'Frilans / Sidoinkomst',
  PENSION_TRANSFERS: 'Pension / Överföringar',
  GIFTS_ONE_OFF_INCOME: 'Gåvor / Engångsinkomst',
};
